import { Link } from "@tanstack/react-router";

import { Card, CardContent } from "../components/ui/card";

// Catch-all 404 surface (ADR 0025 D2). Distinct from ComingSoonPage: this is for
// paths that match no route at all, not a deliberately gated feature. Wired as
// the router's defaultNotFoundComponent so it renders at the root (no auth gate)
// for any unmatched URL.
export function NotFoundPage() {
  return (
    <section
      className="p-6 max-w-3xl mx-auto space-y-4"
      role="region"
      aria-label="Page not found"
    >
      <header>
        <h1 className="font-display text-3xl font-medium tracking-tight text-on-surface">
          Page not found
        </h1>
        <p className="mt-1 text-sm text-on-surface-variant">
          The page you are looking for does not exist.
        </p>
      </header>
      <Card>
        <CardContent>
          <Link
            to="/dashboard"
            className="text-sm font-medium text-primary underline"
          >
            Back to dashboard
          </Link>
        </CardContent>
      </Card>
    </section>
  );
}
